import React from 'react';
import styled, { css } from 'styled-components';

const AspectRatio = ({ children, ratio, ratioMobile, style, styleContent, bg, fogEffect, cursor, noEffect }) => (
    <PictureBox fogEffect={fogEffect} noEffect={noEffect}>
        <AspectRatioStyled
            ratio={ratio}
            ratioMobile={ratioMobile}
            bg={bg}
            style={{ ...style }}
            fogEffect={fogEffect}
            cursor={cursor}
            className="aspect-ratio"
        >
            <Content style={{ ...styleContent }}>{children}</Content>
        </AspectRatioStyled>
    </PictureBox>
);

const ratio = {
    '2x1': 50,
    '4x3': 75,
    '16x9': 56.25,
    '3x2': 66.66,
    '8x5': 62.5,
    '132x181': 137.12
};

const PictureBox = styled.div`
    width: 100%;
    height: 100%;
    overflow: hidden;

    &:hover {
        > div {
            transition: transform 300ms ease;
            transform: ${({ fogEffect, noEffect }) => (!fogEffect && !noEffect ? 'scale(1.04)' : 'none')};
        }
    }
`;

const AspectRatioStyled = styled.div`
    display: flex;
    background-color: #333;
    position: relative;
    width: 100%;
    padding-top: 100%; /* 1:1 Aspect Ratio */
    background-position: center;
    background-size: cover;
    filter: brightness(100%);
    transition: filter 300ms;

    &:hover {
        ${props =>
            props.fogEffect &&
            css`
                filter: brightness(50%);
            `};
        cursor: ${({ cursor }) => cursor ?? 'default'};
    }

    ${props =>
        props.ratio &&
        css`
            padding-top: ${ratio[props.ratio] || props.ratio}%;
        `}

    ${props =>
        props.bg &&
        css`
            background-image: url('${props.bg}');
            background-size: cover;
            background-position: center;
        `}

    @media (max-width: 768px) {
        ${props =>
            props.ratioMobile &&
            css`
                padding-top: ${ratio[props.ratioMobile] || props.ratioMobile}%;
            `}
    }
`;

const Content = styled.div`
    display: flex;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
`;

export default AspectRatio;
